"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchFieldPermission = exports.loadFieldPermissionMap = exports.resetFieldPermissionMap = exports.updateFieldPermissionSetting = exports.updateFieldPermissionMap = void 0;
const action_constants_1 = require("../../../../../../modules/shared/store/action_constants");
const api_1 = require("../../../../../../exports/api");
const redux_batched_actions_1 = require("redux-batched-actions");
const updateFieldPermissionMap = (fieldPermissionMap, datasheetId) => {
    return {
        type: action_constants_1.UPDATE_FIELD_PERMISSION_MAP,
        payload: fieldPermissionMap,
        datasheetId
    };
};
exports.updateFieldPermissionMap = updateFieldPermissionMap;
const updateFieldPermissionSetting = (fieldId, setting, datasheetId) => {
    return {
        type: action_constants_1.UPDATE_FIELD_PERMISSION_SETTING,
        payload: { fieldId, setting },
        datasheetId
    };
};
exports.updateFieldPermissionSetting = updateFieldPermissionSetting;
const resetFieldPermissionMap = (fieldId, datasheetId) => {
    return {
        type: action_constants_1.RESET_FIELD_PERMISSION_MAP,
        payload: fieldId,
        datasheetId
    };
};
exports.resetFieldPermissionMap = resetFieldPermissionMap;
const loadFieldPermissionMap = (fieldPermissionMap, datasheetId) => {
    return {
        type: action_constants_1.LOAD_FIELD_PERMISSION_MAP,
        payload: fieldPermissionMap,
        datasheetId
    };
};
exports.loadFieldPermissionMap = loadFieldPermissionMap;
const fetchFieldPermission = (dstIds) => {
    return (dispatch, getState) => {
        const state = getState();
        const shareId = state.pageParams.shareId || state.pageParams.embedId;
        api_1.DatasheetApi.getFieldPermissionMap(dstIds, shareId).then(res => {
            const { success, data } = res.data;
            if (success) {
                const actions = [];
                for (const v of data) {
                    actions.push((0, exports.loadFieldPermissionMap)(v.fieldPermissionMap, v.datasheetId));
                }
                dispatch((0, redux_batched_actions_1.batchActions)(actions));
            }
        }, err => {
            console.error('getFieldPermissionMap error', err);
        });
    };
};
exports.fetchFieldPermission = fetchFieldPermission;
//# sourceMappingURL=field_permission_map.js.map